export * from './TxtHeading'
export * from './TxtLabel'
export * from './TxtLink'
export * from './TxtParagraph'
export * from './TxtLabelBg'